module.exports = __webpack_public_path__ + "img/manufacture@2x.402e805.webp";